<script lang="ts">
  import { fade } from 'svelte/transition'
  import Portal from 'svelte-portal'

  let {
    show = false,
    title = "",
    onClose = () => {},
    children = null,
  } = $props()

  $effect(() => {
    document.querySelector("body").classList[show ? "add" : "remove"]("modal-showing")
  })
</script>

{#if show}
  <Portal target="#modals-portal">
    <div class="FullScreenModal fs-modal add-action-modal" transition:fade>
      <div class="fs-header">
        <div class="text-right">
          <button type="button" onclick={onClose} class="btn btn-cancel--round" aria-label="Close">
            &nbsp;
          </button>
        </div>

        {#if title}
          <div class="text-center">
            <h1 class="fs-title">{title}</h1>
          </div>
        {/if}
      </div>

      <div class="fs-inner">
        {@render children?.()}
      </div>
    </div>
  </Portal>
{/if}
